import request from './request.js';

/**
 *
 */
function login() {
    let testKey = 'notTest';

    if (Boolean(process.env.REACT_APP_IS_TEST) === true) {
        testKey = "isTest";
    }

    const options = {
        endpoint: `/oauth/login/${ testKey }`,
        method: 'GET',
        skipAuth: true
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 */
function get() {
    const options = {
        endpoint: '/master',
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @returns {Promise<unknown>}
 */
function getMetrics() {
    const options = {
        endpoint: '/master/metrics',
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 */
function getMasterUsers() {
    const options = {
        endpoint: '/master/users',
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 */
function setMasterPermission(masterID, access) {
    const options = {
        endpoint: `/master/${ masterID }/permissions/${ access }`,
        method: 'PUT'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 */
function addMasterUser(body) {
    const options = {
        endpoint: `/master/user/add`,
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 */
function removeMasterUser(masterID) {
    const options = {
        endpoint: `/master/${ masterID }/remove`,
        method: 'DELETE'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} body
 */
function createBrokerage(body) {
    const options = {
        endpoint: '/advisors/brokerage',
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} body
 * @param {*} uploadType
 */
function uploadFile(body, uploadType) {
    const options = {
        endpoint: `/uploads/${ uploadType }`,
        method: 'POST',
        noJson: true,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @returns {Promise<unknown>}
 */
function toggleAvailability() {
    const options = {
        endpoint: '/master/availability',
        method: 'PUT',
        body: {}
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

export {
    login,
    get,
    getMasterUsers,
    addMasterUser,
    setMasterPermission,
    removeMasterUser,
    uploadFile,
    createBrokerage,
    toggleAvailability,
    getMetrics
};